import { useState } from "react";
import logo from "../assets/perpx-logo.png";
import dropdown from "../assets/dropdown.png";
import base from "../assets/base.png";
import polygon from "../assets/polygon.png";
import eth from "../assets/eth.png";
import complere from "../assets/complere.png";
import { useLocation, useNavigate } from "react-router-dom";
import TokenDialog from "./TokenDialog";
import { createThirdwebClient } from "thirdweb";
import { ConnectButton } from "thirdweb/react";
import { darkTheme } from "thirdweb/react";
import { base as baseChain } from "thirdweb/chains";
import coin from "../assets/complere.png";
import coin3 from "../assets/eth.png";
import { createWallet } from "thirdweb/wallets";

const Header = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState("ETH");

    const client = createThirdwebClient({
        clientId: process.env.REACT_APP_THIRD_WEB_CLIENT,
    });

    const customTheme = darkTheme({
        colors: {
            primaryButtonBg: "#5dd3d3",
            primaryButtonText: "#0a1628",
            modalBg: "#0d1f35",
            borderColor: "rgba(93, 211, 211, 0.2)",
            accentText: "#5dd3d3",
            separatorLine: "rgba(93, 211, 211, 0.1)",
            secondaryButtonBg: "rgba(93, 211, 211, 0.1)",
            secondaryButtonHoverBg: "rgba(93, 211, 211, 0.2)",
            secondaryButtonText: "#5dd3d3",
        },
    });

    const openBridge = () => {
        window.open('https://beta-bridge.complere.xyz/', '_blank');
    }

    return (
        <div className="flex bg-perpx-dark-tertiary/30 backdrop-blur-md px-1 sm:px-4 lg:px-8 lg:mx-auto w-full h-[72px] justify-between border-b border-perpx-cyan/10">
            <div className="flex gap-1 sm:gap-4 justify-start sm:justify-center items-center">
                <div className="flex items-center gap-2">
                    <img src={logo} className="w-[40px] h-[40px] perpx-logo-glow" />
                    <h1 className="text-perpx-text-primary text-[24px] font-semibold">PerpX</h1>
                </div>
                <div className="hidden md:flex gap-6 justify-center items-center ml-6">
                    <p
                        onClick={() => navigate("/")}
                        className={`w-[94px] h-fit rounded-[48px] px-[20px] py-[10px] ${pathname === "/"
                            ? "bg-perpx-cyan/20 text-perpx-cyan font-semibold shadow-perpx-glow"
                            : "text-perpx-text-secondary font-medium hover:text-perpx-cyan"
                            } text-[20px] cursor-pointer transition-all duration-300`}
                    >
                        Swap
                    </p>
                    <p
                        onClick={() => navigate("/pool")}
                        className={`w-[94px] h-fit rounded-[48px] px-[20px] py-[10px] ${pathname.startsWith("/pool") || pathname.includes("/remove")
                            ? "bg-perpx-cyan/20 text-perpx-cyan font-semibold shadow-perpx-glow"
                            : "text-perpx-text-secondary font-medium hover:text-perpx-cyan"
                            } text-[20px] cursor-pointer transition-all duration-300`}
                    >
                        Pool
                    </p>
                </div>
            </div>
            <div className="flex gap-2 sm:gap-6 justify-center items-center pt-2 pb-2">
                <ConnectButton
                    connectButton={{
                        label: "Connect Wallet",
                        style: {
                            borderRadius: "64px",
                            background: "#5dd3d3",
                            color: "#0a1628",
                            fontWeight: "600",
                        },
                    }}
                    connectModal={{
                        title: "Sign in with PerpX",
                        titleIcon: logo,
                        size: "wide",
                        welcomeScreen: {
                            title: "Your gateway to the decentralized world",
                            subtitle: "Connect a wallet to get started",
                            img: {
                                src: logo,
                                height: 150,
                                width: 150,
                            },
                        },
                    }}
                    detailsButton={{
                        style: {
                            borderRadius: "64px",
                            background: "rgba(93, 211, 211, 0.1)",
                            color: "#5dd3d3",
                            border: "1px solid rgba(93, 211, 211, 0.2)",
                        },
                    }}
                    wallets={[
                        createWallet("io.metamask"),
                        createWallet("com.coinbase.wallet"),
                        createWallet("me.rainbow"),
                        createWallet("io.rabby"),
                        createWallet("app.phantom"),
                        createWallet("com.trustwallet.app"),
                        createWallet("walletConnect"),
                    ]}
                    chains={[baseChain]}
                    client={client}
                    theme={customTheme}
                    autoConnect={true}
                />
                <TokenDialog open={open} setOpen={setOpen} onClick={setSelected} />
            </div>
        </div>
    );
};

export default Header;
